import React, { useEffect, useRef, useState } from "react";
import { Line, Bar, Pie } from "react-chartjs-2";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import LineChart from "../DashBoard/LineChart";
import { CloudDownloadOutlined, DownloadOutlined } from "@ant-design/icons";
import moment from "moment/moment";
import config from "../../config/config";
import Select from "react-select";
import BarLineLineChart from "../DashBoard/BarLineLineChart";
import dashboardService from "../../services/dashboard-yield-service"
import { capitaliceWord } from "../Utils/StringFormater";


// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashboardYieldHome = () => {


  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);



  const [listCutBunches, setListCutBunches] = useState([]);
  const [listCollectedBunches, setListCollectedBunches] = useState([]);
  const [listDamagedBunches, setListDamagedBunches] = useState([])
  const [cutBunches, setCutBunches] = useState(0);
  const [collectedBunches, setCollectedBunches] = useState(0);





  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)
  const [listLineData, setListLineData] = useState([]);
  const [hectaresData, setHectaresData] = useState([]);

  const [loading, setLoading] = useState(false);

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [farmId, setFarmId] = useState("0");



  const [dataBunches, setDataBunches] = useState([])

  const [totalHectares, setTotalHectares] = useState(0);
  const [totalPalms, setTotalPalms] = useState(0);
  const [bunchesByPalm, setBunchesByPalm] = useState(0);
  const [ApplicationByHectare, setApplicationByHectare] = useState(0);

  const [valuesLotX, setValuesLotX] = useState([])
  const [valuesLotY, setValuesLotY] = useState([])

  registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS_YIELD, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);

  const [listSection, setListSection] = useState(escoja);
  const [sectionId, setSectionId] = useState("0");




  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////




  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };


  const changeStateShowValues = (e) => {
    setShowLineValues(!e.target.checked)
  }

  const changeExpand = (e) => {
    setExpandCharts(e.target.checked)
  }



  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };




  const getBunchesByLot = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setValuesLotX([])
    setValuesLotY([])
    const userId = getValues("userId")
    const result = await dashboardService.getBunchesByLot(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    let listX = [];
    let listY = [];
    if (result) {
      result.map((item) => {
        const lotName =  capitaliceWord(item.lotName);
        const farmName = capitaliceWord(item.farmName);
        const total = item.total;
        if(farmId=="0"){
            listX.push(`${farmName} \n${lotName} `)
        }
        else{
          listX.push(lotName)
        }
        
        listY.push(total)
      });
    }
    setValuesLotX(listX)
    setValuesLotY(listY)
  };







  ///RACIMOS POR DIA
  const getBunchesByDay = async () => {
    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setListLineData([])
    const userId = getValues("userId")

    const params = { startDate: start, endDate: end, farmId, lotId, sectionId, lots: selectedLotes, userId }
    const result = await dashboardService.bunchesByDay(params);
    let list = [];
    let listDamaged = [];

    let dataCutBunches = []
    let dataCollectedtBunches = []


    if (result) {
      result.map((item) => {
        const fecha = formatDate(item._id);
        const cut = item.cutBunches;
        const collected = item.collectedBunches;
        const damaged = item.damagedBunches;

        dataCutBunches.push({ day: fecha, value: cut });
        dataCollectedtBunches.push({ day: fecha, value: collected });
        list.push({ value: [fecha, cut] })
        listDamaged.push({ value: [fecha, damaged] })
      });
    }


    let data = [
      {
        "name": "Recogidos",
        "data": dataCollectedtBunches
      },
      {
        "name": "Cortados",
        "data": dataCutBunches
      }
    ]

    setDataBunches(data)
    setListDamagedBunches(listDamaged)
    setListCollectedBunches(list)
  };




  ////APLICACIONES POR TIPO
  const getTotalBunchesAndPalms = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');


    //setCutBunches(countCutBunches)
    //setCollectedBunches(countCollectedBunches)


    setCutBunches(0);
    setCollectedBunches(0);
    setTotalPalms(0);
    setBunchesByPalm(0)
    setLoading(true);
    const userId = getValues("userId")
    const result = await dashboardService.totalBunchesAndPalms(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    if (result) {
      if (result.length > 0) {


        setCutBunches(result[0].cutBunches);
        setCollectedBunches(result[0].collectedBunches);
        setTotalPalms(result[0].palms);

        const countBunches = result[0].collectedBunches
        const countPalms = result[0].palms

        if (countPalms > 0) {
          const averageByPalm = countBunches / countPalms
          setBunchesByPalm(averageByPalm.toFixed(2))
        }


        setLoading(false);
      }
    }

  };



  const loadDashBoard = () => {
    getTotalBunchesAndPalms();
    getBunchesByDay();
    getBunchesByLot();
  };



  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();





  const cardStyle = {
    padding: "18px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };



  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };







  const getListUsers = async () => {
    const farmId = getValues("farm")
    const lotId = getValues("lot")
    const userId = "0"
    setValue("userId", "0")
    try {
      let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const params = {startDate:start, endDate:end, farmId, sectionId, lotId}
      const response = await userService.listUsersYieldAccumulation(params)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
  }
  useEffect(() => {
    getListUsers();
  }, [startDate, endDate, farmId, sectionId, lotId]);




  useEffect(() => {
    getLisFarm();
    getListUsers()
    loadDashBoard()

    setTimeout(() => {
      chartOneRef.current?.getEchartsInstance().resize();
      chartTwoRef.current?.getEchartsInstance().resize();
      chartThreeRef.current?.getEchartsInstance().resize();
    }, 150);






  }, []);

  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "18px",
      }}
    >

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Dashboard cosecha</Divider>
      </div>


      <div className="row">
        <div className="col-12">
          <form className="form-react">
            <div className="row mb-3">

              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>







              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>





              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Cargar gráficos
                </button>
              </div>


              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>

              <div className=" col-12 col-sm-4 ">
                <label className="text-secondary fw-bold">Usuario</label>
                <select
                  className="form-control text-secondary"
                  {...register("userId")}
                >
                  {listUsers.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>




              <div className="mt-2 col-12 col-sm-2"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeExpand(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Expandir graficas</label>
                </div>
              </div>

              <div className="mt-2 col-2 d-none"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeStateShowValues(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Ocultar valores</label>
                </div>
              </div>


            </div>



          </form>
        </div>



        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#3F51B5" }}>Racimos cortados: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{cutBunches.toLocaleString()}</label>
          </div>
        </div>


        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#3F51B5" }}>Racimos recogidos: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{collectedBunches.toLocaleString()}</label>
          </div>
        </div>






        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#00D9A3" }}>Palmas: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{totalPalms.toLocaleString()}</label>
          </div>
        </div>




        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#00D9A3" }}>Racimos/palma: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{bunchesByPalm.toLocaleString()}</label>
          </div>
        </div>




        <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-6 mt-2"}>
          <div style={cardStyle}>
            <LineChart
              decimals={0}
              data={listCollectedBunches}
              chartRef={chartOneRef}
              title="Racimos por día"
              subTitle="Total de racimos recolectados por día"
              seriesTitle="Racimos"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "racimos-por-dia.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-6 mt-2"}>
          <div style={cardStyle}>
            <LineChart
              decimals={0}
              data={listDamagedBunches}
              chartRef={chartTwoRef}
              title="Malogros por día"
              subTitle="Malogros registrados en el día"
              seriesTitle="Malogros"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartTwoRef, "malogros-por-dia.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>




        <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarLineLineChart
              chartRef={chartThreeRef}
              title="Racimos por lote"
              nameBar="Racimos"
              subTitle=" "
              categories={valuesLotX}
              applications={valuesLotY}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartThreeRef, "racimos-por-lote.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>















      </div>
    </div>
  );
};

export default DashboardYieldHome;